/**
 * RoadmapDeepLinkOpenKind
 *
 * Which sheet a roadmap notification deep-link auto-opens after the
 * single-item fetch — the web split of Flutter's `widget.openComments` /
 * `widget.openLikes` branch (roadmap_screen.dart:457-471).
 *
 * String-valued members keep the discriminated union ergonomic (each member is
 * a distinct discriminator literal) and avoid any serialization surprise. No
 * sibling roadmap enum uses ordinal indexing for this concept, so there is no
 * wire-format ordinal to preserve here.
 */
export enum RoadmapDeepLinkOpenKind {
  likes = 'likes',
  comments = 'comments',
}
